//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IMerchandisingRulesClient {
    /**
     * Obtener reglas de merchandising
     * @param page (optional) Índice de página (inicia en 0)
     * @param size (optional) Cantidad de elementos por página
     * @param q (optional) Término de búsqueda para nombre de regla
     * @param active (optional) Filtrar por estado activo/inactivo
     */
    list(storeId: string, page?: number | undefined, size?: number | undefined, q?: string | undefined, active?: boolean | undefined): Observable<MerchandisingRulePageDto>;
    /**
     * Crear regla de merchandising
     * @return Rule created
     */
    create(storeId: string, body: CreateMerchandisingRuleDto): Observable<void>;
    /**
     * Obtener regla de merchandising
     */
    getById(storeId: string, ruleId: string): Observable<MerchandisingRuleDto>;
    /**
     * Actualizar regla de merchandising
     * @return Rule updated
     */
    update(storeId: string, ruleId: string, body: UpdateMerchandisingRuleDto): Observable<void>;
    /**
     * Eliminar regla de merchandising
     */
    delete(storeId: string, ruleId: string): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class MerchandisingRulesClient implements IMerchandisingRulesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Obtener reglas de merchandising
     * @param page (optional) Índice de página (inicia en 0)
     * @param size (optional) Cantidad de elementos por página
     * @param q (optional) Término de búsqueda para nombre de regla
     * @param active (optional) Filtrar por estado activo/inactivo
     */
    list(storeId: string, page?: number | undefined, size?: number | undefined, q?: string | undefined, active?: boolean | undefined): Observable<MerchandisingRulePageDto> {
        let url_ = this.baseUrl + "/hub/stores/{storeId}/rules/merchandising?";
        if (storeId === undefined || storeId === null)
            throw new globalThis.Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (q === null)
            throw new globalThis.Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (active === null)
            throw new globalThis.Error("The parameter 'active' cannot be null.");
        else if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchandisingRulePageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchandisingRulePageDto>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<MerchandisingRulePageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchandisingRulePageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token inv\u00e1lido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Crear regla de merchandising
     * @return Rule created
     */
    create(storeId: string, body: CreateMerchandisingRuleDto): Observable<void> {
        let url_ = this.baseUrl + "/hub/stores/{storeId}/rules/merchandising";
        if (storeId === undefined || storeId === null)
            throw new globalThis.Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token inv\u00e1lido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Obtener regla de merchandising
     */
    getById(storeId: string, ruleId: string): Observable<MerchandisingRuleDto> {
        let url_ = this.baseUrl + "/hub/stores/{storeId}/rules/merchandising/{ruleId}";
        if (storeId === undefined || storeId === null)
            throw new globalThis.Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (ruleId === undefined || ruleId === null)
            throw new globalThis.Error("The parameter 'ruleId' must be defined.");
        url_ = url_.replace("{ruleId}", encodeURIComponent("" + ruleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchandisingRuleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchandisingRuleDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<MerchandisingRuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchandisingRuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token inv\u00e1lido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Actualizar regla de merchandising
     * @return Rule updated
     */
    update(storeId: string, ruleId: string, body: UpdateMerchandisingRuleDto): Observable<void> {
        let url_ = this.baseUrl + "/hub/stores/{storeId}/rules/merchandising/{ruleId}";
        if (storeId === undefined || storeId === null)
            throw new globalThis.Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (ruleId === undefined || ruleId === null)
            throw new globalThis.Error("The parameter 'ruleId' must be defined.");
        url_ = url_.replace("{ruleId}", encodeURIComponent("" + ruleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token inv\u00e1lido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Eliminar regla de merchandising
     */
    delete(storeId: string, ruleId: string): Observable<void> {
        let url_ = this.baseUrl + "/hub/stores/{storeId}/rules/merchandising/{ruleId}";
        if (storeId === undefined || storeId === null)
            throw new globalThis.Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (ruleId === undefined || ruleId === null)
            throw new globalThis.Error("The parameter 'ruleId' must be defined.");
        url_ = url_.replace("{ruleId}", encodeURIComponent("" + ruleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token inv\u00e1lido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class MerchandisingRulePageDto implements IMerchandisingRulePageDto {
    page!: PageDto;
    items!: MerchandisingRuleDto[];

    [key: string]: any;

    constructor(data?: IMerchandisingRulePageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.page = new PageDto();
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"] ? PageDto.fromJS(_data["page"]) : new PageDto();
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchandisingRuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MerchandisingRulePageDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchandisingRulePageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page ? this.page.toJSON() : undefined as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMerchandisingRulePageDto {
    page: PageDto;
    items: MerchandisingRuleDto[];

    [key: string]: any;
}

export class CreateMerchandisingRuleDto implements ICreateMerchandisingRuleDto {
    name!: string;
    triggerRules!: TriggerRulesInputDto;
    consequenceRules!: ConsequenceRulesInputDto;
    status!: CreateMerchandisingRuleDtoStatus;
    /** Inicio de vigencia (ISO-8601) */
    startDate?: string;
    /** Fin de vigencia (ISO-8601) */
    endDate?: string;

    [key: string]: any;

    constructor(data?: ICreateMerchandisingRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.triggerRules = new TriggerRulesInputDto();
            this.consequenceRules = new ConsequenceRulesInputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.triggerRules = _data["triggerRules"] ? TriggerRulesInputDto.fromJS(_data["triggerRules"]) : new TriggerRulesInputDto();
            this.consequenceRules = _data["consequenceRules"] ? ConsequenceRulesInputDto.fromJS(_data["consequenceRules"]) : new ConsequenceRulesInputDto();
            this.status = _data["status"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
        }
    }

    static fromJS(data: any): CreateMerchandisingRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMerchandisingRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["triggerRules"] = this.triggerRules ? this.triggerRules.toJSON() : undefined as any;
        data["consequenceRules"] = this.consequenceRules ? this.consequenceRules.toJSON() : undefined as any;
        data["status"] = this.status;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        return data;
    }
}

export interface ICreateMerchandisingRuleDto {
    name: string;
    triggerRules: TriggerRulesInputDto;
    consequenceRules: ConsequenceRulesInputDto;
    status: CreateMerchandisingRuleDtoStatus;
    /** Inicio de vigencia (ISO-8601) */
    startDate?: string;
    /** Fin de vigencia (ISO-8601) */
    endDate?: string;

    [key: string]: any;
}

export class MerchandisingRuleDto implements IMerchandisingRuleDto {
    /** ID único de la regla */
    id!: string;
    /** Nombre descriptivo de la regla */
    name!: string;
    /** Reglas que disparan la acción */
    triggerRules!: TriggerRulesDto;
    /** Consecuencias a aplicar */
    consequenceRules!: ConsequenceRulesDto;
    /** Estado de la regla */
    status!: MerchandisingRuleDtoStatus;
    /** Inicio de vigencia (ISO-8601) */
    startDate?: string;
    /** Fin de vigencia (ISO-8601) */
    endDate?: string;

    [key: string]: any;

    constructor(data?: IMerchandisingRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.triggerRules = new TriggerRulesDto();
            this.consequenceRules = new ConsequenceRulesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.triggerRules = _data["triggerRules"] ? TriggerRulesDto.fromJS(_data["triggerRules"]) : new TriggerRulesDto();
            this.consequenceRules = _data["consequenceRules"] ? ConsequenceRulesDto.fromJS(_data["consequenceRules"]) : new ConsequenceRulesDto();
            this.status = _data["status"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
        }
    }

    static fromJS(data: any): MerchandisingRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchandisingRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["triggerRules"] = this.triggerRules ? this.triggerRules.toJSON() : undefined as any;
        data["consequenceRules"] = this.consequenceRules ? this.consequenceRules.toJSON() : undefined as any;
        data["status"] = this.status;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        return data;
    }
}

export interface IMerchandisingRuleDto {
    /** ID único de la regla */
    id: string;
    /** Nombre descriptivo de la regla */
    name: string;
    /** Reglas que disparan la acción */
    triggerRules: TriggerRulesDto;
    /** Consecuencias a aplicar */
    consequenceRules: ConsequenceRulesDto;
    /** Estado de la regla */
    status: MerchandisingRuleDtoStatus;
    /** Inicio de vigencia (ISO-8601) */
    startDate?: string;
    /** Fin de vigencia (ISO-8601) */
    endDate?: string;

    [key: string]: any;
}

export class UpdateMerchandisingRuleDto implements IUpdateMerchandisingRuleDto {
    name?: string;
    triggerRules?: TriggerRulesInputDto;
    consequenceRules?: ConsequenceRulesInputDto;
    status?: UpdateMerchandisingRuleDtoStatus;
    /** Inicio de vigencia (ISO-8601) */
    startDate?: string;
    /** Fin de vigencia (ISO-8601) */
    endDate?: string;

    [key: string]: any;

    constructor(data?: IUpdateMerchandisingRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.triggerRules = _data["triggerRules"] ? TriggerRulesInputDto.fromJS(_data["triggerRules"]) : undefined as any;
            this.consequenceRules = _data["consequenceRules"] ? ConsequenceRulesInputDto.fromJS(_data["consequenceRules"]) : undefined as any;
            this.status = _data["status"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
        }
    }

    static fromJS(data: any): UpdateMerchandisingRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMerchandisingRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["triggerRules"] = this.triggerRules ? this.triggerRules.toJSON() : undefined as any;
        data["consequenceRules"] = this.consequenceRules ? this.consequenceRules.toJSON() : undefined as any;
        data["status"] = this.status;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        return data;
    }
}

export interface IUpdateMerchandisingRuleDto {
    name?: string;
    triggerRules?: TriggerRulesInputDto;
    consequenceRules?: ConsequenceRulesInputDto;
    status?: UpdateMerchandisingRuleDtoStatus;
    /** Inicio de vigencia (ISO-8601) */
    startDate?: string;
    /** Fin de vigencia (ISO-8601) */
    endDate?: string;

    [key: string]: any;
}

export class PageDto implements IPageDto {
    /** Número de página (inicia en 0) */
    number!: number;
    /** Tamaño de página */
    size!: number;
    /** Total de elementos encontrados */
    totalElements!: number;
    /** Total de páginas */
    totalPages!: number;
    /** Indica si la página está vacía */
    empty!: boolean;

    [key: string]: any;

    constructor(data?: IPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.number = _data["number"];
            this.size = _data["size"];
            this.totalElements = _data["totalElements"];
            this.totalPages = _data["totalPages"];
            this.empty = _data["empty"];
        }
    }

    static fromJS(data: any): PageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["number"] = this.number;
        data["size"] = this.size;
        data["totalElements"] = this.totalElements;
        data["totalPages"] = this.totalPages;
        data["empty"] = this.empty;
        return data;
    }
}

export interface IPageDto {
    /** Número de página (inicia en 0) */
    number: number;
    /** Tamaño de página */
    size: number;
    /** Total de elementos encontrados */
    totalElements: number;
    /** Total de páginas */
    totalPages: number;
    /** Indica si la página está vacía */
    empty: boolean;

    [key: string]: any;
}

export class TriggerRulesInputDto implements ITriggerRulesInputDto {
    logicalOperator!: TriggerRulesInputDtoLogicalOperator;
    conditions!: TriggerConditionInputDto[];

    [key: string]: any;

    constructor(data?: ITriggerRulesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.conditions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.logicalOperator = _data["logicalOperator"];
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(TriggerConditionInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TriggerRulesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerRulesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["logicalOperator"] = this.logicalOperator;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITriggerRulesInputDto {
    logicalOperator: TriggerRulesInputDtoLogicalOperator;
    conditions: TriggerConditionInputDto[];

    [key: string]: any;
}

export class ConsequenceRulesInputDto implements IConsequenceRulesInputDto {
    add?: ConsequenceBlockInputDto;
    remove?: ConsequenceBlockInputDto;
    promote?: ConsequenceBlockInputDto;
    demote?: ConsequenceBlockInputDto;

    [key: string]: any;

    constructor(data?: IConsequenceRulesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.add = _data["add"] ? ConsequenceBlockInputDto.fromJS(_data["add"]) : undefined as any;
            this.remove = _data["remove"] ? ConsequenceBlockInputDto.fromJS(_data["remove"]) : undefined as any;
            this.promote = _data["promote"] ? ConsequenceBlockInputDto.fromJS(_data["promote"]) : undefined as any;
            this.demote = _data["demote"] ? ConsequenceBlockInputDto.fromJS(_data["demote"]) : undefined as any;
        }
    }

    static fromJS(data: any): ConsequenceRulesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsequenceRulesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["add"] = this.add ? this.add.toJSON() : undefined as any;
        data["remove"] = this.remove ? this.remove.toJSON() : undefined as any;
        data["promote"] = this.promote ? this.promote.toJSON() : undefined as any;
        data["demote"] = this.demote ? this.demote.toJSON() : undefined as any;
        return data;
    }
}

export interface IConsequenceRulesInputDto {
    add?: ConsequenceBlockInputDto;
    remove?: ConsequenceBlockInputDto;
    promote?: ConsequenceBlockInputDto;
    demote?: ConsequenceBlockInputDto;

    [key: string]: any;
}

export class TriggerRulesDto implements ITriggerRulesDto {
    /** Operador lógico del bloque */
    logicalOperator!: TriggerRulesDtoLogicalOperator;
    /** Lista de condiciones */
    conditions!: TriggerConditionDto[];

    [key: string]: any;

    constructor(data?: ITriggerRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.conditions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.logicalOperator = _data["logicalOperator"];
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(TriggerConditionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TriggerRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["logicalOperator"] = this.logicalOperator;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITriggerRulesDto {
    /** Operador lógico del bloque */
    logicalOperator: TriggerRulesDtoLogicalOperator;
    /** Lista de condiciones */
    conditions: TriggerConditionDto[];

    [key: string]: any;
}

export class ConsequenceRulesDto implements IConsequenceRulesDto {
    /** Reglas para agregar items */
    add?: ConsequenceBlockDto;
    /** Reglas para quitar items */
    remove?: ConsequenceBlockDto;
    /** Reglas para promocionar items */
    promote?: ConsequenceBlockDto;
    /** Reglas para degradar items */
    demote?: ConsequenceBlockDto;

    [key: string]: any;

    constructor(data?: IConsequenceRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.add = _data["add"] ? ConsequenceBlockDto.fromJS(_data["add"]) : undefined as any;
            this.remove = _data["remove"] ? ConsequenceBlockDto.fromJS(_data["remove"]) : undefined as any;
            this.promote = _data["promote"] ? ConsequenceBlockDto.fromJS(_data["promote"]) : undefined as any;
            this.demote = _data["demote"] ? ConsequenceBlockDto.fromJS(_data["demote"]) : undefined as any;
        }
    }

    static fromJS(data: any): ConsequenceRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsequenceRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["add"] = this.add ? this.add.toJSON() : undefined as any;
        data["remove"] = this.remove ? this.remove.toJSON() : undefined as any;
        data["promote"] = this.promote ? this.promote.toJSON() : undefined as any;
        data["demote"] = this.demote ? this.demote.toJSON() : undefined as any;
        return data;
    }
}

export interface IConsequenceRulesDto {
    /** Reglas para agregar items */
    add?: ConsequenceBlockDto;
    /** Reglas para quitar items */
    remove?: ConsequenceBlockDto;
    /** Reglas para promocionar items */
    promote?: ConsequenceBlockDto;
    /** Reglas para degradar items */
    demote?: ConsequenceBlockDto;

    [key: string]: any;
}

export class TriggerConditionInputDto implements ITriggerConditionInputDto {
    term!: string;
    operator!: TriggerConditionInputDtoOperator;

    [key: string]: any;

    constructor(data?: ITriggerConditionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.term = _data["term"];
            this.operator = _data["operator"];
        }
    }

    static fromJS(data: any): TriggerConditionInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerConditionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["term"] = this.term;
        data["operator"] = this.operator;
        return data;
    }
}

export interface ITriggerConditionInputDto {
    term: string;
    operator: TriggerConditionInputDtoOperator;

    [key: string]: any;
}

export class ConsequenceBlockInputDto implements IConsequenceBlockInputDto {
    logicalOperator!: ConsequenceBlockInputDtoLogicalOperator;
    conditions!: ConsequenceConditionInputDto[];

    [key: string]: any;

    constructor(data?: IConsequenceBlockInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.conditions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.logicalOperator = _data["logicalOperator"];
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(ConsequenceConditionInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsequenceBlockInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsequenceBlockInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["logicalOperator"] = this.logicalOperator;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConsequenceBlockInputDto {
    logicalOperator: ConsequenceBlockInputDtoLogicalOperator;
    conditions: ConsequenceConditionInputDto[];

    [key: string]: any;
}

export class TriggerConditionDto implements ITriggerConditionDto {
    /** Término a evaluar */
    term!: string;
    /** Operador de coincidencia */
    operator!: TriggerConditionDtoOperator;

    [key: string]: any;

    constructor(data?: ITriggerConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.term = _data["term"];
            this.operator = _data["operator"];
        }
    }

    static fromJS(data: any): TriggerConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["term"] = this.term;
        data["operator"] = this.operator;
        return data;
    }
}

export interface ITriggerConditionDto {
    /** Término a evaluar */
    term: string;
    /** Operador de coincidencia */
    operator: TriggerConditionDtoOperator;

    [key: string]: any;
}

export class ConsequenceBlockDto implements IConsequenceBlockDto {
    logicalOperator!: ConsequenceBlockDtoLogicalOperator;
    conditions!: ConsequenceConditionDto[];

    [key: string]: any;

    constructor(data?: IConsequenceBlockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.conditions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.logicalOperator = _data["logicalOperator"];
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(ConsequenceConditionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsequenceBlockDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsequenceBlockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["logicalOperator"] = this.logicalOperator;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConsequenceBlockDto {
    logicalOperator: ConsequenceBlockDtoLogicalOperator;
    conditions: ConsequenceConditionDto[];

    [key: string]: any;
}

export class ConsequenceConditionInputDto implements IConsequenceConditionInputDto {
    type!: ConsequenceConditionInputDtoType;
    value!: string;
    operator!: ConsequenceConditionInputDtoOperator;

    [key: string]: any;

    constructor(data?: IConsequenceConditionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.value = _data["value"];
            this.operator = _data["operator"];
        }
    }

    static fromJS(data: any): ConsequenceConditionInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsequenceConditionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["value"] = this.value;
        data["operator"] = this.operator;
        return data;
    }
}

export interface IConsequenceConditionInputDto {
    type: ConsequenceConditionInputDtoType;
    value: string;
    operator: ConsequenceConditionInputDtoOperator;

    [key: string]: any;
}

export class ConsequenceConditionDto implements IConsequenceConditionDto {
    /** Tipo de dato sobre el que aplica */
    type!: ConsequenceConditionDtoType;
    /** Valor de la condición */
    value!: string;
    operator!: ConsequenceConditionDtoOperator;

    [key: string]: any;

    constructor(data?: IConsequenceConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.value = _data["value"];
            this.operator = _data["operator"];
        }
    }

    static fromJS(data: any): ConsequenceConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsequenceConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["value"] = this.value;
        data["operator"] = this.operator;
        return data;
    }
}

export interface IConsequenceConditionDto {
    /** Tipo de dato sobre el que aplica */
    type: ConsequenceConditionDtoType;
    /** Valor de la condición */
    value: string;
    operator: ConsequenceConditionDtoOperator;

    [key: string]: any;
}

export enum CreateMerchandisingRuleDtoStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export enum MerchandisingRuleDtoStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export enum UpdateMerchandisingRuleDtoStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export enum TriggerRulesInputDtoLogicalOperator {
    AND = "AND",
    OR = "OR",
}

export enum TriggerRulesDtoLogicalOperator {
    AND = "AND",
    OR = "OR",
}

export enum TriggerConditionInputDtoOperator {
    IS = "IS",
    CONTAINS = "CONTAINS",
}

export enum ConsequenceBlockInputDtoLogicalOperator {
    AND = "AND",
    OR = "OR",
}

export enum TriggerConditionDtoOperator {
    IS = "IS",
    CONTAINS = "CONTAINS",
}

export enum ConsequenceBlockDtoLogicalOperator {
    AND = "AND",
    OR = "OR",
}

export enum ConsequenceConditionInputDtoType {
    TERM = "TERM",
    BRAND = "BRAND",
    CATEGORY = "CATEGORY",
    SKU_REF_ID = "SKU_REF_ID",
    PRODUCT_REF_ID = "PRODUCT_REF_ID",
    SPECIFICATION = "SPECIFICATION",
    SELLER = "SELLER",
}

export enum ConsequenceConditionInputDtoOperator {
    IS = "IS",
    CONTAINS = "CONTAINS",
}

export enum ConsequenceConditionDtoType {
    TERM = "TERM",
    BRAND = "BRAND",
    CATEGORY = "CATEGORY",
    SKU_REF_ID = "SKU_REF_ID",
    PRODUCT_REF_ID = "PRODUCT_REF_ID",
    SPECIFICATION = "SPECIFICATION",
    SELLER = "SELLER",
}

export enum ConsequenceConditionDtoOperator {
    IS = "IS",
    CONTAINS = "CONTAINS",
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}